import React, { useState } from 'react';
import { Modal, Form } from 'react-bootstrap'; // Importing necessary components from React-Bootstrap
import { Button } from 'react-bootstrap'; // Button component
import { MdOutlineAdd } from "react-icons/md"; // Add icon
import { FaPencil } from "react-icons/fa6"; // Pencil icon for editing
// import Editor from './Editor'; // Custom Editor component for note editing


const Notes = () => {
  // State to manage modal visibility
  const [showModal, setShowModal] = useState(false);

  // Function to toggle modal visibility
  const handleAddClick = () => {
    setShowModal(true); // Show modal
  };
  const handleCloseModal = () => {
    setShowModal(false); // Close modal
  };

  const [, setIsFormVisible] = useState(false); // Placeholder state for form visibility

  const handleSaveClick = () => {
    setIsFormVisible(false); // Hide form after saving
    alert('Provider details saved successfully!'); // Alert on save
  };

  // State to manage notes list
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState(""); // Temporary note input state

  // Function to save new note
  const handleSaveNote = () => {
    if (newNote.trim() !== "") {
      const noteObject = {
        id: notes.length + 1, // Auto-increment id based on current notes length
        text: newNote, // Note content
        author: "Admin SM", // Author name
        timestamp: new Date().toLocaleString(), // Timestamp of note creation
      };

      setNotes((prevNotes) => [...prevNotes, noteObject]); // Add new note to state
      setNewNote(""); // Clear input
      setShowModal(false); // Close modal after saving
    } else {
      alert("Note cannot be empty!"); // Prevent saving empty notes
    }
  };

  // Function to delete note
  const handleDeleteNote = (id) => {
    setNotes(notes.filter(note => note.id !== id)); // Remove note by id
  };

  return (
    <div>
      <h5 style={{ backgroundColor: "white", color: "#004aad", padding: "5px", fontWeight: "bold", fontSize:"24px" }}>
        Notes
      </h5>

      {/* Form for External ID and Regional Customer ID */}
      <div style={{
        alignItems: 'center',
        fontSize: '0.9rem',
        marginRight: '20px',
        backgroundColor: '#f2f2f2', // Background color
        border: "1px solid #ccc", 
        padding: "10px", 
        borderTop: "3px solid #004aad", // Top border color
      }}>
        <br />
        {/* External ID input */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ marginLeft: '10px' }}>External ID</strong>
          <Form.Control
            type="text"
            placeholder=""
            style={{
              width: '160px',
              height:"35px",
              fontSize: '0.9rem',
              padding: '0.5rem',
              marginLeft:"125px"
            }}
          />
        </div>
        <br />
        {/* Regional Customer ID input */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ marginLeft: '10px' }}>Regional Customer ID</strong>
          <Form.Control
            type="text"
            placeholder=""
            style={{
              width: '160px',
              height:"35px",
              fontSize: '0.9rem',
              padding: '0.5rem',
              marginLeft:"50px"
            }}
          />
        </div>
        <br />
      </div>

      <br />
      {/* Button to add a note */}
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button onClick={handleAddClick} style={{
          backgroundColor: "#004aad",
          color: "white",
          border: "none",
          padding: "8px 12px",
          fontSize: "14px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          borderRadius: "4px",
          marginBottom: "10px",
          marginRight:"15px"
        }}>
          <MdOutlineAdd size={18} style={{ marginRight: "5px" }} /> Add Note
        </button>
      </div>

      {/* Display existing notes */}
      <div>
        {notes.map((note) => (
          <div key={note.id} style={{
            backgroundColor: "#fff",
            padding: "10px",
            margin: "10px 0",
            border: "1px solid #ccc",
            borderRadius: "4px",
            position: "relative"
          }}>
            <strong>{note.author}</strong>
            <br />
            <em style={{ fontSize: "0.8rem", color: "gray" }}>{note.timestamp}</em>
            <p>{note.text}</p>

            {/* Delete button for each note */}
            <button 
              onClick={() => handleDeleteNote(note.id)} 
              style={{
                backgroundColor: "red",
                color: "white",
                border: "none",
                padding: "5px 8px",
                fontSize: "12px",
                cursor: "pointer",
                position: "absolute",
                top: "10px",
                right: "10px",
                borderRadius: "4px"
              }}
            >
              Delete
            </button>
          </div>
        ))}
      </div>

      {/* Modal for Adding Notes */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg" dialogClassName="custom-modal">
        <Modal.Header closeButton style={{
          backgroundColor: "#004aad",
          color: "white",
          fontWeight: "bold",
          fontSize: "18px",
        }}>
          <Modal.Title>Account Note</Modal.Title>
        </Modal.Header>
        
        <Modal.Body style={{ height: "300px", overflowY: "auto", padding: "15px" }}>
          {/* <Editor value={newNote} onChange={(content) => setNewNote(content)} style={{
            width: "100%",
            height: "200px",
            border: "1px solid #ccc",
            borderRadius: "4px",
          }}/> */}
        </Modal.Body>

        <Modal.Footer style={{ justifyContent: "flex-end" }}>
          <Button variant="secondary" onClick={handleCloseModal} style={{
            backgroundColor: "#004aad",
            borderColor: "#004aad",
            padding: "6px 15px",
            fontSize: "14px",
          }}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveNote} style={{
            backgroundColor: "#004aad",
            borderColor: "#004aad",
            padding: "6px 15px",
            fontSize: "14px",
          }}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Save button */}
      <Button
        style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad',
          marginRight: '',
        }}
        onClick={handleSaveClick}
      >
        <FaPencil style={{ marginRight: '6px' }} />
        Save
      </Button>
    </div>
  );
};

export default Notes;
